/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CvSearchProcessStatusDto = {
    Created: 'CREATED',
    Running: 'RUNNING',
    Paused: 'PAUSED',
    Finished: 'FINISHED',
    Error: 'ERROR',
} as const;

export type CvSearchProcessStatusDto = typeof CvSearchProcessStatusDto[keyof typeof CvSearchProcessStatusDto];



